// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"504":"84382475","787":"0f269576","790":"893e63d7","929":"c35c064e"}[chunkId] + ".chunk.js";
};